import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { BusinessError } from '@modules/error/classes';
import { AccessCodeAndClientSecret, AuthFormNotificationType, AuthFormType } from '@shared/models/auth.interface';
import { BusinessOperationErrorTypes } from '@shared/models/error.interface';

import { AuthService } from '@shared/services/auth/auth.service';
import { AppService, LoadingService } from '@shared/services/core';
import { BehaviorSubject } from 'rxjs';

const demoAnimation = trigger('demoAnimation', [
  transition(':enter', [
    style({ transform: 'translateX({{ from }})' }),
    animate('{{ time }}', style({ transform: 'translateX(0%)' }))
  ]),
])

@Component({
  selector: 'app-access-code-form',
  templateUrl: './access-code-form.component.html',
  styleUrls: ['./access-code-form.component.scss'],
  animations: [demoAnimation]
})
export class AccessCodeFormComponent implements OnInit {
  @Input() lastFormTracker = new BehaviorSubject<AuthFormType>("ACCESSCODE");
  @Output() notify = new EventEmitter<AuthFormNotificationType>();
  @Output() result = new EventEmitter<{ code: string, logo: string} | undefined>();

  accessCodeForm: FormGroup = new FormGroup({
    code: new FormControl('', [Validators.required, Validators.maxLength(3), accessCodeValidator()]),
  });

  constructor(
    private authService: AuthService,
    private appService: AppService,
    private loadingService: LoadingService,
  ) { }

  ngOnInit(): void {
    this.authService.checkKeepMeLoggedIn();
  }

  proceedForLogin() {
    const requestBody: AccessCodeAndClientSecret = {
      code: this.accessCodeForm.get('code')!.value,
      clientId: this.appService.getAppSettings().apiCredentials.clientID,
      clientSecret: this.appService.getAppSettings().apiCredentials.clientSecret
    }

    console.log('Request body generated for access code.');

    this.loadingService.showLoading();
    this.authService.checkAccessToken(requestBody).pipe()
    .subscribe({
      next: (response) => {
        if (response && response.data) this.result.next({ code: requestBody.code, logo: `data:image/jpg;base64, ${response.data.clientLogo}` });
        this.loadingService.stopLoading();
      },
      error: (err: Error) => {
        console.log('Error Name:');
        console.log(err.name);
        console.log('Error Message:');
        console.log(err.message);
        console.log('Error Stack:');
        console.log(err.stack);
        if (err instanceof BusinessError && (err.title as BusinessOperationErrorTypes) === "PORTAL_UNAVAILABLE") {
          this.notify.next("ACCESS_DENIED");
        } else if (err instanceof BusinessError && (err.title as BusinessOperationErrorTypes) === "INVALID_ACCESSCODE") {
          this.notify.next("ACCESSCODE_ERROR");
        } else 
          this.notify.next("ACCESS_DENIED");
        this.loadingService.stopLoading();
      },
    });
  }
}

function accessCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const accessCode = control.value;

    if (accessCode.length > 0 && accessCode.length < 3) return { invalidLength: true }
    else return null;
  }
}